export default {
  en_US: {
    broker: 'Invitations',
    trade: 'Exchange',
    otc: 'OTC',
    fiat: 'Fiat',
    lever: 'Margin',
    co: 'Contract',
    assets: 'Wallet',
    order: 'Orders',
    zh: 'Chinese',
    login: 'Login',
    register: 'Sign Up',
    more: 'More',
    moreText: 'More',
    account: 'Account',
    message: 'Message',
    set: ' ',
    color: 'Mode',
    userStatus: 'Account',
    out: 'Log Out',
    userStatus1: 'Normal',
    userStatus2: 'Freeze the transaction, freeze the withdrawal',
    userStatus3: 'Freeze the transaction 3 freeze the withdrawal',
    minings: 'Transaction mining',
    innov_tit: 'Innovation test area',
    appDownLoad: 'APP',
  },
  ar_SA: {
    broker: 'الدعوات',
    trade: 'التداول',
    otc: 'التداول المباشر',
    fiat: 'البيع والشراء',
    lever: 'رافعة التداول',
    co: 'العقود',
    assets: 'المحفظة',
    order: 'الطلبات',
    zh: 'الصينية البسيطة',
    login: 'دخول',
    register: 'إنشاء حساب',
    more: 'رؤية المزيد',
    moreText: 'المزيد',
    account: 'المركز الشخصي',
    message: 'رسالة',
    set: 'الإعدادات',
    color: 'الوضعية',
    userStatus: 'حالة الحساب',
    out: 'خروج',
    userStatus1: 'طبيعي',
    userStatus2: 'تجميد التداول، تجميد السحب',
    userStatus3: 'تجميد التداول 3، تجميد السحب',
    minings: 'تعدين المعاملات',
    innov_tit: 'قسم اختبار الابتكارات',
    appDownLoad: 'تنزيل التطبيق',
  },
};
